var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.65,1.59s.05,0,.07,0c.81.02,1.84.29,2.43.88.43.37.73.86.93,1.39.22.59.26,1.16.29,1.78.08,1.4.09,2.81.03,4.21-.05,1.2-.08,2.41-.93,3.36-.59.65-1.42.98-2.27,1.11-.75.11-1.51.12-2.26.12-.64,0-1.28,0-1.91,0-.38,0-.75,0-1.13,0-1.1-.02-2.25-.16-3.11-.91-.64-.57-.99-1.38-1.12-2.21-.1-.64-.12-1.28-.12-1.92,0-1.16,0-2.33,0-3.49,0-.95.14-1.98.69-2.78.48-.7,1.22-1.14,2.03-1.34,1.05-.26,2.18-.2,3.26-.22s2.07,0,3.11.03ZM6.35,2.74c-1.19.03-2.57,0-3.24,1.18-.37.66-.35,1.34-.37,2.06-.05,1.41-.08,2.96,0,4.37.1,1.93.74,2.78,2.72,2.9,1.5.09,3.37.08,4.87,0,1.93-.1,2.78-.74,2.9-2.72.09-1.5.08-3.37,0-4.87-.1-1.91-.72-2.77-2.7-2.9-1.33-.09-2.85-.05-4.19-.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.63,4.72c2.38-.21,4.22,1.98,3.5,4.28-.82,2.62-4.37,3.12-5.89.83-1.35-2.03-.05-4.9,2.39-5.11ZM7.71,5.88c-.83.08-1.57.76-1.78,1.56-.54,2.05,1.86,3.57,3.46,2.2s.48-3.98-1.67-3.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.4,3.8c1.04-.02,1.02,1.55.02,1.55s-1.02-1.54-.02-1.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.16a9a32236b2b6d1857a9687d7b9001b.svg";
export { ForwardRef as ReactComponent };